import { Tooltip } from "./Tooltip";

const AGE_TOOLTIP =
  "Please enter the age of the principal insured (the main policyholder). " +
  "Premiums differ for members under 65 and 65 and older.";

interface AgeInputProps {
  value: number;
  onChange: (age: number) => void;
  min: number;
  max: number;
}

/** Age of the principal insured — slider and number box kept in sync. */
export function AgeInput({ value, onChange, min, max }: AgeInputProps) {
  // Clamp typed input to the allowed range; ignore empty/NaN mid-typing.
  const commit = (raw: string) => {
    const n = Number.parseInt(raw, 10);
    if (Number.isNaN(n)) return;
    onChange(Math.min(max, Math.max(min, n)));
  };

  return (
    <div className="field">
      <label className="field__label" htmlFor="age-number">
        Age of principal insured
        <Tooltip text={AGE_TOOLTIP} label="About the age input" />
      </label>
      <div className="age">
        <input
          type="range"
          className="age__slider"
          min={min}
          max={max}
          value={value}
          aria-label="Age slider"
          onChange={(e) => onChange(Number(e.target.value))}
        />
        <input
          id="age-number"
          type="number"
          className="age__number"
          inputMode="numeric"
          min={min}
          max={max}
          value={value}
          aria-label="Age"
          onChange={(e) => commit(e.target.value)}
        />
      </div>
    </div>
  );
}
